import { type PropsWithChildren } from "react"

import { useIsDesktop } from "@/utils/useIsDesktop"

interface SwitchContainerProps extends PropsWithChildren {
  className?: string
}

export const SwitchContainer = ({
  className,
  children,
  ...rest
}: SwitchContainerProps) => {
  const isDesktop = useIsDesktop()

  return (
    <div
      className={`${isDesktop ? "m-[0_1rem]" : "m-0"} flex min-w-[3.5rem] justify-end ${className ?? ""}`}
      {...rest}
    >
      {children}
    </div>
  )
}
